import type { SelfDescribingJson } from '@snowplow/browser-tracker';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Placement, ProductType } from '../types';

interface InactivityEventData {
  totalTime: number;
  product: ProductType;
  category: Placement;
  description?: string;
}

/**
 * Track Inactivity view event in Snowplow.
 * v.0.26.0;
 * @public
 *
 * @param eventData - Object that contains event properties described in the Inactivity Event document
 * (see https://healthcareinc.atlassian.net/wiki/spaces/ENGINEERING/pages/3740237845/Inactivity#Schema-Fields).
 *
 * @example
 * ```ts
 *
 * import {trackInactivity} from '@hc-frontend/third-party-snowplow';
 *
 * trackInactivity({
 *   total_time: 60000,
 *   product: 'HEALTH',
 *   category: 'SURVEY',
 *   description: '...',
 * });
 * ```
 */
function trackInactivity(
  eventData: InactivityEventData,
  contexts?: Array<SelfDescribingJson> | null,
): void {
  const { totalTime, product, category, description } = eventData;

  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.healthcare/inactivity/jsonschema/1-0-1',
      data: {
        total_time: totalTime,
        product: product.toLocaleLowerCase(),
        category: category.toLocaleLowerCase(),
        description,
      },
    },
    context: contexts,
  });
}

export type { InactivityEventData };
export { trackInactivity };
